import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Endo.module.scss';
import endoImg from '../../../shared/assets/photo/endo/mirror.png';
import endoImg_2x from '../../../shared/assets/photo/endo/mirror_2x.png';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Endo = () => {

    useGSAP(() => {     
        gsap.to(".endoImg", 
            {  
            duration: 2,          
            border: '2px solid #30AFB8',
            scrollTrigger: {
                trigger: ".endoImg"
        }});
    }, [])

    return ( 
        <section> 
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.container}>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>
                        Глубокие кариозные полости и травмы могут привести к серьезному 
                        инфицированию зубов, поскольку бактерии из вашего рта достигают 
                        пульпы или внутреннего слоя зуба. Это не только может быть чрезвычайно 
                        болезненно, но и  часто приводит к потере зубов.
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                        
                        В последнее время всё чаще кариес протекает бессимптомно. 
                        Если раньше считалось, что боль — это основной признак кариеса, 
                        то теперь всё изменилось. Зуб, подверженный кариесу, может абсолютно 
                        никак не беспокоить. Таким образом, очень часто разрушение зуба или даже 
                        его потеря являются для пациента неприятной неожиданностью.                
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                       
                        Необходимо регулярно посещать кабинет стоматолога, чтобы вовремя 
                        обнаружить проблему и провести грамотное лечение, а также 
                        профилактические мероприятия и не допустить появления кариеса вовсе.
                </Text>
            </Stack>
            <Stack 
                justifyContent='justifyStart'
                alignItems ='alignCenter'
                className={styles.dark}>
                    <Stack
                        direction = 'column'
                        gap = '16'
                        justifyContent='justifyStart'
                        alignItems ='alignCenter'
                        className={styles.content}>   
                            <Text                             
                                size ='xl'
                                className={styles.textTitle}>
                                    Эндодонтия                            
                            </Text>                       
                            <Text                             
                                size ='m'
                                className={styles.text}>                       
                                    Эндодонтия –  это диагностика и лечение заболеваний 
                                    корневых каналов.                          
                            </Text>
                            <Text                             
                                size ='m'
                                className={styles.text}>               
                                    Эта процедура направлена ​​на удаление поврежденной пульпы, 
                                    дезинфекции тканей и 
                                    добавления пломбы в корневой канал для герметизации
                                    и предотвращения будущей инфекции. 
                            </Text>
                            <Text                             
                                size ='m'
                                className={styles.text}>
                                    Лечение корневых каналов остановит дальнейшее разрушение зуба, 
                                    и вы почувствуете немедленное облегчение боли.
                            </Text>
                    </Stack>
                        <div className={styles.imgContainer}>
                                <img className={`endoImg ${styles.picture}`} src={endoImg}
                                        srcSet={`${endoImg_2x} 2x`} alt="эндодонтия" />
                        </div>
            </Stack>
        </section>
    );
}
export default Endo;